export function timeToSeconds (Time) {
	return function (time) {
		return Time.timeToSeconds(time);
	};
}
